import { STORAGE_KEY } from '@/constant/constant';
import { safeJsonParse } from '../utils/safeJsonParse';
import { commonApi, getShopifyUserId } from '../service/api';
import { getLocal } from '@/utils/storage';

/**
 * 根据是否配置 discount 拉取折扣码并回填到 settings/responseData，再执行 callback
 */
export function checkDiscountLogic(options: {
  settings: any;
  responseData: any;
  id: string;
  setSettings: (s: any) => void;
  /** 拉取/回填完成后执行（如打开弹窗） */
  callback?: () => void;
}) {
  const { settings, responseData, id, setSettings, callback } = options;

  if (settings?.discount) {
    /** 当前客户信息（邮箱等），用于 discountCode 接口 */
    const customer = safeJsonParse<any>(getLocal(STORAGE_KEY.CARTX_CUSTOMER), {} as any);
    commonApi(
      {
        shopifyUserId: getShopifyUserId(),
        formId: id,
        email: customer?.email
      },
      'form/out/discountCode'
    )
      .then((response) => {
        /** 接口返回的折扣码，回填到 rules/banner */
        const discountCode = response?.data?.data?.discountCode;
        if (responseData?.settings?.rules) responseData.settings.rules.couponCode = discountCode;
        if (responseData?.settings?.banner) responseData.settings.banner.bannerCouponCode = discountCode;
        if (settings?.rules) settings.rules.couponCode = discountCode;
        if (settings?.banner) settings.banner.bannerCouponCode = discountCode;
        setSettings(settings);

        if (discountCode && (process.env.REACT_APP_DEPLOY_ENV === 'shopify' || process.env.REACT_APP_DEPLOY_ENV === 'shopifyTest')) {
          fetch(window.location.origin + `/discount/${discountCode}`);
        }
        callback?.();
      })
      .catch(() => {});
  } else {
    if (responseData?.settings?.rules?.couponCode && (process.env.REACT_APP_DEPLOY_ENV === 'shopify' || process.env.REACT_APP_DEPLOY_ENV === 'shopifyTest')) {
      fetch(window.location.origin + `/discount/${responseData.settings.rules.couponCode}`);
    }
    callback?.();
  }
}
